import useApiConfig from './useApiConfig';
import { PaymentMethod } from '../reducers/financialCalculators';
import { useGetWarrantiesQuery } from '../apis/hondaRestApi';
import { usePageState } from '../../utils/sitecoreContext';
export const useFetchWarranties = (transmissionIds, bodyStyle, paymentMethod, term, annualKmAllowance) => {
    const apiConfig = useApiConfig();
    const pageState = usePageState();
    // cash does not have terms associated with it so it would naturally be 0,
    // therefore this avoids a "skip" false positive
    // TODO: review the necessity of this, now that the term field is removed from the payload when cash is selected
    const isValidCashPayment = term === 0 && paymentMethod === PaymentMethod.cash;
    const payload = {
        ...apiConfig,
        transmissionIds: transmissionIds === null || transmissionIds === void 0 ? void 0 : transmissionIds.join(';'),
        bodyStyle,
        annualKmAllowance,
        paymentMethod,
        term,
        pageState,
    };
    // Exclude the term field when the payment method is cash
    if (paymentMethod === PaymentMethod.cash)
        delete payload.term;
    const { data, isFetching, isLoading, isSuccess, isUninitialized, error } = useGetWarrantiesQuery(payload, {
        skip: !transmissionIds || !bodyStyle || (!isValidCashPayment && !term) || !paymentMethod,
    });
    return {
        warranties: data,
        isFetching,
        isLoading,
        isSuccess,
        isUninitialized,
        error,
    };
};
export default useFetchWarranties;
